import { Reveal } from "./Reveal";

const BENEFITS = [
  {
    n: "01",
    title: "Learn Beach",
    desc: "Understand how indoor skills translate to the beach game.",
  },
  {
    n: "02",
    title: "Stay Flexible",
    desc: "Experience beach volleyball without committing to an entire season.",
  },
  {
    n: "03",
    title: "Have Fun Competing",
    desc: "High-quality training in an energetic, positive environment.",
  },
];

export const WhyBreak = () => (
  <section id="why" className="py-20 md:py-28">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-deep/70 flex items-center gap-2">
              <span className="w-8 h-px bg-sun" /> Why Beach Break
            </p>
            <h2 className="mt-4 font-display uppercase text-deep leading-[0.95] text-[clamp(2.6rem,6vw,4.5rem)]">
              A <span className="font-serifit italic normal-case text-sun">new</span> way to play.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.1}>
            <p className="text-base md:text-lg text-deep-soft leading-relaxed">
              Many volleyball players are interested in beach volleyball — but may not want to
              join another full club season or commit before knowing whether beach is for them.
            </p>
            <p className="mt-5 text-base md:text-lg text-deep-soft leading-relaxed">
              Beach Break gives them a flexible entry point through camps and clinics specifically
              designed to help athletes transition their skills to the sand.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mt-14 md:mt-20 grid md:grid-cols-3 gap-x-8 gap-y-10">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.n} delay={0.1 * i}>
            <div data-testid={`benefit-card-${i}`} className="group border-t-2 border-deep/15 pt-6 hover:border-sun transition-colors duration-300 h-full">
              <p className="font-mono text-xs tracking-[0.2em] text-deep/50 group-hover:text-sun transition-colors duration-300">
                {b.n}
              </p>
              <h3 className="mt-3 font-display uppercase text-deep text-2xl md:text-3xl">{b.title}</h3>
              <p className="mt-3 text-sm md:text-base text-deep-soft leading-relaxed">{b.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyBreak;
